import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Download, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { newsletterAPI } from '../../services/api';

const API = process.env.REACT_APP_BACKEND_URL;

const NewslettersManager = () => {
  const [items, setItems] = useState([]);

  const load = useCallback(async () => {
    try { const res = await newsletterAPI.getAll(); setItems(res.data || []); }
    catch { toast.error('Failed to load'); }
  }, []);

  useEffect(() => { load(); }, [load]);
  const handleDownload = () => {
    const token = localStorage.getItem('admin_token');
    window.open(`${API}/api/admin/newsletters/download?token=${token}`, '_blank');
  };

  return (
    <div className="max-w-4xl">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <div>
            <CardTitle>Newsletter Subscribers</CardTitle>
            <CardDescription>{items.length} subscribers</CardDescription>
          </div>
          <Button onClick={handleDownload} variant="outline" data-testid="download-newsletters-csv">
            <Download className="w-4 h-4 mr-2" /> Download CSV
          </Button>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            {items.map(s => (
              <div key={s._id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                <div>
                  <p className="font-medium text-gray-900">{s.email}</p>
                  <p className="text-xs text-gray-500">{new Date(s.subscribed_at).toLocaleString()}</p>
                </div>
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${s.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}>
                  {s.status}
                </span>
              </div>
            ))}
            {items.length === 0 && <p className="text-center py-8 text-gray-500">No subscribers yet.</p>}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default NewslettersManager;
